<template>
  <div class="scoring-console">
    <div v-if="type !== 'operate'">
      <div class="match">
        <img :src="imageView(game.matchIcon, 100, 100)" />
        <div class="match-name">{{ game.matchName }}</div>
        <div class="group-name">{{ game.groupName }}</div>
        <div class="group-name">{{ game.roundDescription }}</div>
        <div class="team">
          {{ game.homeTeamName }}
          <span>VS</span>
          {{ game.awayTeamName }}
        </div>
      </div>
      <div class="btn" @click="goUpdateGame('start')">开始比赛</div>
    </div>
    <div v-else class="operate">
      <div class="outside flex-center">
        <div class="left">
          <div class="title">比赛用时</div>
          <div class="time">{{ gameTime }}</div>
          <div class="update-time">
            <div :class="{'disable': status === 'readyToRun'}" @click="updateTime(-60)">-1 min</div>
            <div :class="{'disable': status === 'readyToRun'}" @click="updateTime(60)">+1 min</div>
          </div>
        </div>
        <div class="right">
           <div class="start-btn" v-if="status === 'readyToRun'" @click="startBMFieldGameWarmup">开始走表</div>
           <div v-else>
            <div class="pause-btn" @click="showPause = true">比赛暂停</div>
            <div class="end-btn" @click="endGame">比赛结束</div>
           </div>
        </div>
      </div>
      <div class="content" v-if="game.id">
        
        <!-- 根据 isReverse 动态渲染队伍位置 -->
        <div class="info flex-center">
          <!-- 左侧队伍 -->
          <div class="left">
            <div class="team-name">{{ isReverse === 1 ? ( game.awayAlias || game.awayTeamName) : ( game.homeAlias || game.homeTeamName) }}</div>
            <div class="score" :style="{'background-color': isReverse === 1 ? game.awayClothesColor : game.homeClothesColor, 'color': getTextColor(isReverse === 1 ? game.awayClothesColor : game.homeClothesColor)}" :class="{'disable': status === 'readyToRun'}" @click="updateScore(isReverse === 1 ? 'away' : 'home')">
              {{ isReverse === 1 ? game.gameStage.awayScore : game.gameStage.homeScore }}
              <div class="score-btn" :style="{'color': getTextColor(isReverse === 1 ? game.awayClothesColor : game.homeClothesColor)}">+1</div>
            </div>
            <div class="score-minus" :style="{'color': getTextColor(isReverse === 1 ? game.awayClothesColor : game.homeClothesColor),'background-color': isReverse === 1 ? game.awayClothesColor : game.homeClothesColor}" @click="minusScore(isReverse === 1 ? 'away' : 'home')">-1</div>
            <div v-if="gameType === '沙滩排球'" class="players">
              <div v-for="item in (isReverse === 1 ? game.awayPlayers : game.homePlayers)" :key="item.id" class="player" :class="{'active': servingSide === (isReverse === 1 ? 'away_' : 'home_') + item.servingSeq }" @click="exchangeServingSide((isReverse === 1 ? 'away_' : 'home_') + item.servingSeq)">
                <div class="seq">{{ item.servingSeq }}</div>
                <div class="name overflow-text">{{ item.name }}</div>
              </div>
            </div>
            <div v-else class="volleyball-icon" @click="exchangeServingSide(isReverse === 0 ? 'home' : 'away')">
              <img src="@/assets/volleyball-active-icon.png" v-if="servingSide === (isReverse === 0 ? 'home' : 'away')" />
              <img src="@/assets/volleyball-icon.png"  v-else />
            </div>
            <div class="pause">暂停：{{ isReverse === 1 ? game.awayTimeoutCount : game.homeTimeoutCount }} 次</div>
            <div class="pause" style="margin-top: 10px;" v-if="gameType !== '沙滩排球'">换人：{{ game?.rules?.substitutionLimit - (isReverse === 1 ? game.awaySubstitutionCount : game.homeSubstitutionCount) }} 次</div>
          </div>
          
          <!-- 中间部分 -->
          <div class="centre">
            <div class="status">
              <span v-if="status === 'readyToRun'">未开赛</span>
              <span v-else>第{{ game.gameStage.seq }}局</span>
            </div>
            <div class="max-score-box">
              <div class="max-score flex-center">
                <div :style="{'color': getTextColor(isReverse === 1 ? game.awayClothesColor : game.homeClothesColor),'background-color': isReverse === 1 ? game.awayClothesColor : game.homeClothesColor}">
                  <span v-if="(isReverse === 1 ? game.awayScore : game.homeScore) == -1">-</span>
                  <span v-else>{{ isReverse === 1 ? game.awayScore : game.homeScore }}</span>
                </div>
                <div :style="{'color': getTextColor(isReverse === 1 ? game.homeClothesColor : game.awayClothesColor),'background-color': isReverse === 1 ? game.homeClothesColor : game.awayClothesColor}">
                  <span v-if="(isReverse === 1 ? game.homeScore : game.awayScore) == -1">-</span>
                  <span v-else>{{ isReverse === 1 ? game.homeScore : game.awayScore }}</span>
                </div>
              </div>
              <div class="end-btn" @click="endGameStage">结束本局</div>
              <div class="golden-switch">
                <van-switch v-model="isGolden" size="24px" :active-value="1" :inactive-value="0" @change="changeGolden" />
                <div>金局</div>
              </div>
              <div class="exchange-btn" v-if="false">
                <div @click="exchangeServingSide">
                  <img src="@/assets/exchange-btn-icon.png" />
                  交换发球
                </div>
              </div>
            </div>
          </div>
          
          <!-- 右侧队伍 -->
          <div class="right">
            <div class="team-name">{{ isReverse === 1 ? ( game.homeAlias || game.homeTeamName) : ( game.awayAlias || game.awayTeamName) }}</div>
            <div class="score" :style="{'background-color': isReverse === 1 ? game.homeClothesColor : game.awayClothesColor, 'color': getTextColor(isReverse === 1 ? game.homeClothesColor : game.awayClothesColor)}" :class="{'disable': status === 'readyToRun'}" @click="updateScore(isReverse === 1 ? 'home' : 'away')">
              {{ isReverse === 1 ? game.gameStage.homeScore : game.gameStage.awayScore }}
              <div class="score-btn" :style="{'color': getTextColor(isReverse === 1 ? game.homeClothesColor : game.awayClothesColor)}">+1</div>
            </div>
            <div class="score-minus" :style="{'color': getTextColor(isReverse === 1 ? game.homeClothesColor : game.awayClothesColor),'background-color': isReverse === 1 ? game.homeClothesColor : game.awayClothesColor}" @click="minusScore(isReverse === 1 ? 'home' : 'away')">-1</div>
            <div v-if="gameType === '沙滩排球'" class="players">
              <div v-for="item in (isReverse === 1 ? game.homePlayers : game.awayPlayers)" :key="item.id" class="player" :class="{'active': servingSide === (isReverse === 1 ? 'home_' : 'away_') + item.servingSeq }" @click="exchangeServingSide((isReverse === 1 ? 'home_' : 'away_') + item.servingSeq)">
                <div class="seq">{{ item.servingSeq }}</div>
                <div class="name overflow-text">{{ item.name }}</div>
              </div>
            </div>
            <div v-else class="volleyball-icon" @click="exchangeServingSide(isReverse === 0 ? 'away' : 'home')">
              <img src="@/assets/volleyball-active-icon.png" v-if="servingSide === (isReverse === 0 ? 'away' : 'home')" />
              <img src="@/assets/volleyball-icon.png"  v-else />
            </div>
            <div class="pause">暂停：{{ isReverse === 1 ? game.homeTimeoutCount : game.awayTimeoutCount }} 次</div>
            <div class="pause" style="margin-top: 10px;" v-if="gameType !== '沙滩排球'">换人：{{ game?.rules?.substitutionLimit - (isReverse === 1 ? game.homeSubstitutionCount : game.awaySubstitutionCount) }} 次</div>
          </div>
        </div>
        
        <div class="tabs">
          <div class="tab" :class="{'disable': status === 'readyToRun'}" @click="revokeScore" v-if="false">
            <div class="img"><img src="@/assets/chexiaodefen.png" style="width: 17px;height: 14px;" /></div>
            撤销得分
          </div>
          <div class="tab" @click="exchangeField">
            <div class="img"><img src="@/assets/jiaohuanchangdi.png" style="width: 23px;height: 18px;" /></div>
            交换场地
          </div>
          <div class="tab" v-if="gameType !== '沙滩排球'" @click="showSubstitution = true">
            <div class="img"><img src="@/assets/huanren.png" style="width: 21px;height: 23px;" /></div>
            换人
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="item" @click="openScore">
        <img src="@/assets/score-update-icon.png" />
        <div>比分编辑</div>
      </div>
      <div class="item" @click="goUpdateGame('update')">
        <img src="@/assets/game-update-icon.png" />
        <div>比赛编辑</div>
      </div>
    </div>

    <!-- popup -->
    <van-popup v-model="showPause" :close-on-click-overlay="false">
      <div class="pause-select">
        <div class="title">请选择暂停方式</div>
        <div class="item" @click="pause('technical')">技术暂停</div>
        <div class="item" @click="pause('home')">{{game.homeTeamName}}暂停 <span>剩{{ game?.rules?.timeoutLimit - game.homeTimeoutCount }}次</span></div>
        <div class="item" @click="pause('away')">{{game.awayTeamName}}暂停 <span>剩{{ game?.rules?.timeoutLimit - game.awayTimeoutCount }}次</span></div>
        <div class="item cancel" @click="showPause = false">取消</div>
      </div>
    </van-popup>
    <van-popup v-model="showPauseEnd" :close-on-click-overlay="false">
      <div class="pause-end-box">
        <div class="title">
          <span v-if="pauseType === 'technical'">技术暂停</span>
          <span v-else-if="pauseType === 'home'">{{ game.homeTeamName }}暂停</span>
          <span v-else>{{ game.awayTeamName }}暂停</span>
        </div>
        <div class="time">{{ pauseEndTimeText }}</div>
        <div class="text">暂停倒计时</div>
        <div class="btn1">
          <div class="cancel-btn1" v-if="pauseType !== 'technical'" @click="cancelPause">撤销暂停</div>
          <div class="end-btn1" @click="endPause">结束暂停</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showScore" position="bottom">
      <div class="score-box">
        <div class="score-title">比分编辑</div>
        <div class="score-box">
          <div class="score-team" :class="{'reverse': isReverse === 1}">
            <div class="score-team-name overflow-text">{{ game.homeTeamName }}</div>
            <div class="score-team-name overflow-text">{{ game.awayTeamName }}</div>
          </div>
          <div class="score-max" :class="{'reverse': isReverse === 1}">
            <div>
              <span>{{ calculateTotalScore?.homeScore }}</span>
            </div>
            <div>
              <span>{{ calculateTotalScore?.awayScore }}</span>
            </div>
          </div>
          <div class="score-list">
            <div class="score-item" v-for="item in gameStages" :key="item.seq" :class="{'reverse': isReverse === 1}">
              <div class="score-item-score">
                <input type="number" v-model="item.homeScore" min="0" placeholder="-" />
              </div>
              <div class="score-item-seq">
                <img src="@/assets/dangqianjv.png" v-if="item.seq === game.gameStage.seq" />
                <span :class="{'active': item.seq === game.gameStage.seq}">第{{ item.seq }}局</span>
              </div>
              <div class="score-item-score">
                 <input type="number" v-model="item.awayScore" min="0" placeholder="-" />
              </div>
            </div>
          </div>
        </div>
        <div class="score-btn flex-center" style="padding: 0;">
          <div class="revoke-btn" @click="resetGame">
            <img src="@/assets/reset-icon.png" alt="">
            比赛重置
          </div>
          <div class="revoke-btn" @click="revokeEdit">
            <img src="@/assets/revoke-icon.png" alt="">
            撤销编辑
          </div>
          <div class="save-btn" @click="saveScore">保存比分</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showSubstitution" position="bottom">
      <div class="substitution-box">
        <div class="title">换人</div>
        <div class="box flex-center">
         <div class="team">
          <div class="team-name">{{ game.homeTeamName }}</div>
          <div class="number">剩余{{ game?.rules?.substitutionLimit - game.homeSubstitutionCount }}次</div>
          <div class="minus" :class="{'disable': game.homeSubstitutionCount === game.rules?.substitutionLimit}" @click="minusSubstitution('home',1)">-1</div>
          <div class="add" :class="{'disable': game.homeSubstitutionCount === 0}" @click="minusSubstitution('home',-1)">+1</div>
         </div>
         <div class="team">
          <div class="team-name">{{ game.awayTeamName }}</div>
          <div class="number">剩余{{ game?.rules?.substitutionLimit - game.awaySubstitutionCount }}次</div>
          <div class="minus" :class="{'disable': game.awaySubstitutionCount === game.rules?.substitutionLimit}" @click="minusSubstitution('away',1)">-1</div>
          <div class="add" :class="{'disable': game.awaySubstitutionCount === 0}" @click="minusSubstitution('away',-1)">+1</div>
        </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { adminGetScoreboardGame, addBMGameLiveTag,adminCancelLatestPauseTag,adminAddBMGameClock,adminUpdateBMGameServingSide,getBMGameStageList,updateBMGameStages2,adminCancelLatestGoalTag,adminGetScoreboardOngoingGame,adminReverseBMGameScoreboard,addBMGameLiveScore,adminAddBMGameTeamSubstitutionCount,adminResetScoreboardGame, adminUpdateBMGameStageIsGolden } from '@/api/match'
import { QNImageUtil } from '@/utils'
import Vue from 'vue';
import { Popup, Dialog, Switch } from 'vant';
Vue.use(Popup).use(Dialog).use(Switch);
import '@/assets/font-icon/demo.css'
export default {
  data() {
    return {
      unionMatchId: '',
      gameId: '',
      id: '',
      game: {},
      type: '',
      status: '',
      gameType: '',
      timer: null, // 定时器
      currentTime: 0, // 当前时间戳，用于触发响应式更新
      showPause: false,
      pauseType: '',
      showPauseEnd: false,
      pauseEndTime: 0,
      pauseTimer: null,
      servingSide: '',
      showScore: false,
      gameStages: [],
      isReverse: 0,
      showSubstitution: false,
      isGolden: 0
    };
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.gameId = this.$route.query.gameId
    this.id = this.$route.query.id
    this.type = this.$route.query.type || ''
    this.adminGetScoreboardGame()
  },
  
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.clearTimer()
    if(this.pauseTimer) {
      clearInterval(this.pauseTimer)
      this.pauseTimer = null
    }
  },
  computed: {
    // 比赛用时
    gameTime() {
      if (this.game.gameClock && this.game.gameClock.lastActivateUtcSeconds) {
        // 使用 currentTime 来触发响应式更新
        const now = this.currentTime || new Date().getTime()
        const time = now / 1000 - this.game.gameClock.lastActivateUtcSeconds + (this.game.gameClock.enclosedSeconds || 0)
        const hours = Math.floor(time / 3600)
        const minutes = Math.floor((time % 3600) / 60)
        const seconds = Math.floor(time % 60)
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      }
      return '00:00:00'
    },
    pauseEndTimeText() { 
      // 将 pauseEndTime 转为 00:00 格式返回
      const minutes = Math.floor(this.pauseEndTime / 60)
      const seconds = Math.floor(this.pauseEndTime % 60)
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    // 计算总分
    calculateTotalScore() {
      let homeScore = 0
      let awayScore = 0
      
      // 找到有分数的最后一局，将其当作进行中的局，不计算到总分中
      let lastScoredStageIndex = -1
      for (let i = this.gameStages.length - 1; i >= 0; i--) {
        const stage = this.gameStages[i]
        if (stage.homeScore !== '' && stage.awayScore !== '') {
          lastScoredStageIndex = i
          break
        }
      }
      
      // 只计算到倒数第二局（不包括最后一局）
      const stagesToCount = lastScoredStageIndex >= 0 ? this.gameStages.slice(0, lastScoredStageIndex) : this.gameStages
      
      stagesToCount.forEach(item => {
        if (item.homeScore !== '') {
          if (item.awayScore !== '') { 
            if(item.homeScore > item.awayScore) {
              homeScore++
            } else if(item.homeScore < item.awayScore) {
              awayScore++
            }
          } else {
            homeScore++
          }
        } else if(item.awayScore !== '') {
          awayScore++
        }
      })
      
      return {
        homeScore,
        awayScore
      }
    }
  },
  methods: {
    changeGolden() {
      adminUpdateBMGameStageIsGolden({gameId: this.gameId, isGolden: this.isGolden}).then(() => {
        this.adminGetScoreboardGame()
      })
    },
    getBMGameStageList() {
      getBMGameStageList({gameId: this.gameId}).then(res => {
        const { data } = res
        const gameStages = data.gameStages
        const list = []
        for(let i = 0; i < this.game.rules.subGameCount; i++) {
          const obj = {
            seq: gameStages[i]?.seq || i + 1,
            homeScore: gameStages[i]?.homeScore || '',
            awayScore: gameStages[i]?.awayScore || '',
            id: gameStages[i]?.id || ''
          }
          if (gameStages[i] && gameStages[i].homeScore === 0) { 
            obj.homeScore = 0
          }
          if (gameStages[i] && gameStages[i].awayScore === 0) { 
            obj.awayScore = 0
          }
          list.push(obj)
        }
        this.gameStages = list
        this.showScore = true
      })
    },
    startBMFieldGameWarmup() {
      addBMGameLiveTag({
        gameId: this.gameId,
        eventType: 'begin',
        updateScore: 1,
        endUtcSeconds: -1,
        beginUtcSeconds: -1,
        utcSeconds: new Date().getTime() / 1000
      }).then(() => {
        this.adminGetScoreboardGame()
      })
    },
    adminGetScoreboardGame() {
      adminGetScoreboardGame({ unionMatchId: this.unionMatchId, gameId: this.gameId,id: this.id }).then(res => {
        const { data } = res
        this.game = data
        if (data.gameClock?.status === 'running') { // 进行中时 当比分达到胜负时 结束比赛
          const maxScore = (data.rules.subGameCount - 1) / 2 + 1
          console.log(maxScore,'maxScore');
          
          if (data.homeScore >= maxScore || data.awayScore >= maxScore) {
            this.endGame('end')
          }
        }
        // 没有clock节点 或 prepareDone=0, 需要展示 ‘开始比赛'页面
        if (!data.gameClock || data.gameClock.prepareDone === 0) {
          // if(!this.type === 'operate'){
          //   this.type = 'startGame'
          // }
          this.type = 'startGame'
        } else {
          this.type = 'operate'
        }
        this.isReverse = data.isReverse
        this.servingSide = data.servingSide
        this.gameType = data.gameType
        this.status = data.gameClock?.status
        this.isGolden = data.gameStage.isGolden || 0
        if (data.latestTag) { // 最新事件，判断当前是否暂停
          if (data.latestTag.eventType === 'pause_technical') { // 技术暂停
            const utcSeconds = data.latestTag.utcSeconds
            const technicalTimeoutDuration = data.rules.technicalTimeoutDuration
            // 判断当前是否还在暂停时间内
            const now = new Date().getTime() / 1000
            if (now < utcSeconds + technicalTimeoutDuration) {
              this.pauseEndTime = utcSeconds + technicalTimeoutDuration - now
              this.pauseType = 'technical'
              this.pauseTimer = setInterval(() => {
                this.pauseEndTime--
                if(this.pauseEndTime <= 0) {
                  this.showPauseEnd = false
                  clearInterval(this.pauseTimer)
                  this.pauseTimer = null
                  this.adminGetScoreboardGame()
                }
              }, 1000)
              this.showPauseEnd = true
            }
          } else if(data.latestTag.eventType === 'pause') { // 球队暂停
            const utcSeconds = data.latestTag.utcSeconds
            const timeoutDuration = data.rules.timeoutDuration
            // 判断当前是否还在暂停时间内
            const now = new Date().getTime() / 1000
            if (now < utcSeconds + timeoutDuration) {
              this.pauseEndTime = utcSeconds + timeoutDuration - now
              this.pauseType = data.latestTag.teamId === this.game.homeTeamId ? 'home' : 'away'
              this.pauseTimer = setInterval(() => {
                this.pauseEndTime--
                if(this.pauseEndTime <= 0) {
                  this.showPauseEnd = false
                  clearInterval(this.pauseTimer)
                  this.pauseTimer = null
                  this.adminGetScoreboardGame()
                }
              }, 1000)
              this.showPauseEnd = true
            }
          }
        }
        // 处理定时器逻辑
        this.handleTimer()
      })
    },
    updateTime(time) {
      if(this.status === 'readyToRun') {
        return
      }
      adminAddBMGameClock({
        gameId: this.gameId,
        seconds: time
      }).then(() => {
        this.adminGetScoreboardGame()
      })
    },
    minusScore(type) { 
      console.log(type,'type');
      
      const params = {
        gameId: this.gameId,
        required: false
      }
      if(type === 'home'){
        if(this.game.gameStage.homeScore <= 0){
          return
        }
        params.homeAddScore = -1
      } else if(type === 'away'){
        if (this.game.gameStage.awayScore <= 0) {
          return
        }
        params.awayAddScore = -1
      }
      addBMGameLiveScore(params).then(() => {
        this.adminGetScoreboardGame()
      })
    },
    minusSubstitution(type,num) {
      if(type === 'home'){
        if(this.game.homeSubstitutionCount === this.game.rules.substitutionLimit && num === 1){
          return
        }
        if(this.game.homeSubstitutionCount === 0 && num === -1){
          return
        }
      } else if(type === 'away'){
        if(this.game.awaySubstitutionCount === this.game.rules.substitutionLimit && num === 1){
          return
        }
        if(this.game.awaySubstitutionCount === 0 && num === -1){
          return
        }
      }
      const params = {
        gameId: this.gameId,
        teamId: type === 'home' ? this.game.homeTeamId : this.game.awayTeamId,
        count: num
      }
      adminAddBMGameTeamSubstitutionCount(params).then(() => {
        this.adminGetScoreboardGame()
        this.showSubstitution = false
      })
    },
    goUpdateGame(type) {
      adminGetScoreboardOngoingGame({ id: this.id, gameId: this.gameId }).then(res => {
        if(res){
          const { data } = res
          if(data.gameId && data.gameId !== this.gameId){
            Dialog.confirm({
              title: '提示',
              message: '记分台正在使用中'
            })
          } else {
            this.$router.push({
              path: '/match-manage/update-game/' + this.unionMatchId,
              query: {
                gameId: this.gameId,
                id: this.id,
                type
              }
            })
          }
        }
      })
    },
    exchangeServingSide(type) {
      const params = {
        gameId: this.gameId
      }
      if (this.gameType === '沙滩排球') { 
        if (this.servingSide === 'home_1') {
          params.servingSide = 'away_1'
        } else if (this.servingSide === 'away_1') {
          params.servingSide = 'home_2'
        } else if (this.servingSide === 'home_2') {
          params.servingSide = 'away_2'
        } else if (this.servingSide === 'away_2') {
          params.servingSide = 'home_1'
        } else {
          params.servingSide = 'home_1'
        }
      } else {
        if (this.servingSide === 'home') {
          params.servingSide = 'away'
        } else {
          params.servingSide = 'home'
        }
      }
      if (type) {
        params.servingSide = type
      }
      adminUpdateBMGameServingSide(params).then(() => {
        this.adminGetScoreboardGame()
      })
    },
    revokeEdit() {
      this.getBMGameStageList()
    },
    saveScore() {
      const params = {
        gameId: this.gameId
      }
      let stages = JSON.parse(JSON.stringify(this.gameStages))
      stages = stages.filter(item => item.homeScore !== '' && item.awayScore !== '')
      params.stages = JSON.stringify(stages)
      updateBMGameStages2(params).then(() => {
        this.adminGetScoreboardGame()
        this.showScore = false
      })
    },
    revokeScore() {
      adminCancelLatestGoalTag({gameId: this.gameId}).then(() => {
        this.adminGetScoreboardGame()
      })
    },
    exchangeField() {
      const newIsReverse = this.isReverse === 0 ? 1 : 0
      adminReverseBMGameScoreboard({gameId: this.gameId, isReverse: newIsReverse}).then(() => {
        // 立即更新本地状态
        this.isReverse = newIsReverse
        // 然后重新获取比赛数据
        this.adminGetScoreboardGame()
      })
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    },
    
    // 根据背景颜色计算合适的字体颜色
    getTextColor(backgroundColor) {
      if (!backgroundColor) return '#FFFFFF'
      
      // 移除 # 号
      const hex = backgroundColor.replace('#', '')
      
      // 如果是3位十六进制，转换为6位
      const fullHex = hex.length === 3 ? hex.split('').map(char => char + char).join('') : hex
      
      // 转换为RGB值
      const r = parseInt(fullHex.substr(0, 2), 16)
      const g = parseInt(fullHex.substr(2, 2), 16)
      const b = parseInt(fullHex.substr(4, 2), 16)
      
      // 计算亮度 (使用相对亮度公式)
      const brightness = (r * 0.299 + g * 0.587 + b * 0.114)
      
      // 如果背景较亮，使用深色字体；如果背景较暗，使用浅色字体
      return brightness > 128 ? '#000000' : '#FFFFFF'
    },
    endGame(type) {
      const text = type === 'end' ? '已决出胜负，是否结束比赛？\n 结束比赛后，将无法再次进入本场记分台，是否确认立即结束比赛？' :'结束比赛后，将无法再次进入本场记分台，是否确认立即结束比赛？'
      Dialog.confirm({
        title: '提示',
        message: text
      }).then(() => {
        // AddBMGameLiveTag.json
        const params = {
          gameId: this.gameId,
          updateScore: 1,
          eventType: 'end',
          isNewSection: 1,
          endUtcSeconds: -1,
          beginUtcSeconds: -1,
          utcSeconds: new Date().getTime() / 1000
        }
        params.gameClockSeconds = new Date().getTime() / 1000 - this.game.gameClock.lastActivateUtcSeconds + (this.game.gameClock.enclosedSeconds || 0)
        addBMGameLiveTag(params).then(() => {
          this.$toast('比赛结束')
          this.$router.back()
        })
      })
    },
    pause(type) {
      this.pauseType = type
      if (type === 'home') { 
        if( this.game?.rules?.timeoutLimit - this.game.homeTimeoutCount <= 0) {
          this.$toast('暂停次数已用完')
          return
        }
      } else if(type === 'away') {
        if( this.game?.rules?.timeoutLimit - this.game.awayTimeoutCount <= 0) {
          this.$toast('暂停次数已用完')
          return
        }
      }
      const params = {
        gameId: this.gameId,
        updateScore:0,
        eventType:type === 'technical' ? 'pause_technical' : 'pause',
        endUtcSeconds:"-1",
        beginUtcSeconds:"-1",
        utcSeconds:new Date().getTime() / 1000
      }
      if(type !== 'technical') {
        params.teamId = type === 'home' ? this.game.homeTeamId : this.game.awayTeamId
      }
      //   gameClockSeconds: this.gameTime, gameTime 转换为秒
      params.gameClockSeconds = new Date().getTime() / 1000 - this.game.gameClock.lastActivateUtcSeconds + (this.game.gameClock.enclosedSeconds || 0)
      addBMGameLiveTag(params).then(() => {
        if(type === 'technical') {
          this.pauseEndTime = this.game.rules.technicalTimeoutDuration
        } else {
          this.pauseEndTime = this.game.rules.timeoutDuration
        }
        // this.pauseTimer = setInterval(() => {
        //   this.pauseEndTime--
        //   if(this.pauseEndTime <= 0) {
        //     this.showPauseEnd = false
        //     clearInterval(this.pauseTimer)
        //     this.pauseTimer = null
        //     this.adminGetScoreboardGame()
        //   }
        // }, 1000)
        this.adminGetScoreboardGame()
        this.showPause = false
        this.showPauseEnd = true
      })
      console.log(type)
    },
    cancelPause() {
      adminCancelLatestPauseTag({
        gameId: this.gameId
      }).then(() => {
        clearInterval(this.pauseTimer)
        this.pauseTimer = null
        this.showPauseEnd = false
        this.adminGetScoreboardGame()
      })
    },
    resetGame() {
      Dialog.confirm({
        title: '提示',
        message: '重置比赛将清空比分，是否确认'
      }).then(() => {
        adminResetScoreboardGame({gameId: this.gameId}).then(() => {
          this.adminGetScoreboardGame()
          this.showScore = false
        })
      })
    },
    updateScore(type) {
      if(this.status === 'readyToRun') {
        return
      }
      const params = {
        gameId: this.gameId,
        updateScore: 1,
        eventType: 'goal',
        endUtcSeconds: -1,
        beginUtcSeconds: -1,
        utcSeconds: new Date().getTime() / 1000
      }
      if(type === 'home') {
        params.teamId = this.game.homeTeamId
      } else {
        params.teamId = this.game.awayTeamId
      }
      params.gameClockSeconds = new Date().getTime() / 1000 - this.game.gameClock.lastActivateUtcSeconds + (this.game.gameClock.enclosedSeconds || 0)
      addBMGameLiveTag(params).then(() => {
        this.updateServingSide(type)
        // this.adminGetScoreboardGame()
      })
    },
    updateServingSide(type) {
      if (type === 'home' && !(this.servingSide === 'home_1' || this.servingSide === 'home_2' || this.servingSide === 'home')) {
        this.exchangeServingSide()
      } else if (type === 'away' && !(this.servingSide === 'away_1' || this.servingSide === 'away_2' || this.servingSide === 'away')) {
        this.exchangeServingSide()
      } else {
        this.adminGetScoreboardGame()
      }
    },
    endPause() {
      const params = {
        gameId: this.gameId,
        updateScore: 0,
        eventType: 'resume',
        endUtcSeconds: -1,
        beginUtcSeconds: -1,
        utcSeconds: new Date().getTime() / 1000
      }
      addBMGameLiveTag(params).then(() => {
        this.showPauseEnd = false
        clearInterval(this.pauseTimer)
        this.pauseTimer = null
        this.adminGetScoreboardGame()
      })
    },
    endGameStage() {
      if(this.game.gameStage.homeScore === this.game.gameStage.awayScore){
        this.$toast('两队得分相同，无法结束')
        return
      }
      const params = {
        gameId: this.gameId,
        updateScore: 1,
        eventType: 'setEnd',
        isSectionEnd: 1,
        endUtcSeconds: -1,
        beginUtcSeconds: -1,
        utcSeconds: new Date().getTime() / 1000
      }
      params.gameClockSeconds = new Date().getTime() / 1000 - this.game.gameClock.lastActivateUtcSeconds + (this.game.gameClock.enclosedSeconds || 0)
      addBMGameLiveTag(params).then(res => {
        if (res) {
           const params = {
            gameId: this.gameId,
            updateScore: 1,
            eventType: 'resume',
            isNewSection: 1,
            endUtcSeconds: -1,
            beginUtcSeconds: -1,
            utcSeconds: new Date().getTime() / 1000
          }
          params.gameClockSeconds = new Date().getTime() / 1000 - this.game.gameClock.lastActivateUtcSeconds + (this.game.gameClock.enclosedSeconds || 0)
          addBMGameLiveTag(params).then(() => {
            this.adminGetScoreboardGame()
          })
        }
      })
    },
    openScore() {
      this.getBMGameStageList()
    },
    // 处理定时器逻辑
    handleTimer() {
      // 清除之前的定时器
      this.clearTimer()
      
      if (this.status === 'running') {
        // 如果状态是运行中，初始化当前时间并创建定时器
        this.currentTime = new Date().getTime()
        this.startTimer()
      }
    },
    // 开始定时器
    startTimer() {
      this.timer = setInterval(() => {
        // 更新当前时间戳，触发响应式更新
        this.currentTime = new Date().getTime()
      }, 1000)
    },
    
    // 清除定时器
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
};
</script>

<style scoped lang="scss">
.scoring-console{
  min-height: 100vh;
  background: linear-gradient(180deg, #DBEBFA -1%, rgba(185, 185, 185, 0) 38%);
  padding-bottom: 150px;
  box-sizing: border-box;
  .match{
    text-align: center;
    color: #1D2129;
    img{
      width: 62px;
      height: 62px;
      border-radius: 50%;
      margin-top: 37px;
    }
    .match-name{
      font-size: 18px;
      font-weight: 500;
      margin-top: 19px;
    }
    .group-name{
      font-size: 16px;
      font-weight: 500;
      margin-top: 11px;
    }
    .team{
      font-size: 16px;
      color: #303133;
      margin-top: 19px;
      span{
        margin: 0 30px;
      }
    }
  }
  .btn{
    width: 132px;
    height: 45px;
    border-radius: 5px;
    background-color: #337ECC;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    margin: 0 auto;
    margin-top: 66px;
    text-align: center;
    line-height: 45px;
  }
  .footer{
    position: fixed;
    bottom: 0;
    box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
    left: 0;
    right: 0;
    height: 50px;
    background-color: #fff;
    padding-bottom: 34px;
    display: flex;
    justify-content: space-around;
    padding-left: 17px;
    .item{
      text-align: center;
      font-size: 12px;
      color: #303133;
      margin-right: 20px;
      padding-top: 14px;
      img{
        width: 29px;
        height: 29px;
        margin-bottom: 2px;
      }
    }
  }

  .operate{
    background-color: #F7F7F7;
    .outside{
      height: 175px;
      background-color: #FFF;
      box-sizing: border-box;
      padding: 23px 21px 26px 30px;
      border-bottom: 10px solid #F7F7F7;
      .left{
        .title{
          font-size: 18px;
          color: #171717;
        }
        .time{
          font-size: 40px;
          font-weight: 600;
          color: #151515;
        }
        .update-time{
          display: flex;
          font-size: 12px;
          font-weight: 500;
          color: #fff;
          margin-top: 6px;
          div{
            width: 70px;
            height: 26px;
            border-radius: 3px;
            background: #409EFF;
            text-align: center;
            line-height: 26px;
            margin-right: 18px;
          }
        }
      }
      .right{
        .start-btn{
          width: 105px;
          height: 116px;
          border-radius: 4px;
          text-align: center;
          line-height: 105px;
          background-color: #F9503E;
          color: #fff;
          font-size: 18px;
          font-weight: 500;
        }
        .pause-btn{
          width: 105px;
          height: 50px;
          border-radius: 4px;
          background: #2F2F2F;
          color: #FFFFFF;
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          line-height: 50px;
        }
        .end-btn{
          margin-top: 15px;
          width: 105px;
          height: 50px;
          border-radius: 4px;
          background: #F9503E;
          color: #FFFFFF;
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          line-height: 50px;
        }
      }
    }
    .content{
      background-color: #fff;
      height: 411px;
      padding: 20px 22px;
      box-sizing: border-box;
      .info{
        align-items: flex-start;
        
        // 场地交换样式
        &.reverse {
          flex-direction: row-reverse !important;
          
          // 确保子元素顺序正确
          .left {
            order: 3;
          }
          
          .centre {
            order: 2;
          }
          
          .right {
            order: 1;
          }
        }
        
        .team-name{
          text-align: center;
          color: #303133;
          font-size: 16px;
          font-weight: 500;
          height: 50px;
        }
        .centre{
          flex: 1;
          margin: 0 19px;
          .status{
            color: #606266;
            font-size: 14px;
            text-align: center;
          }
          .max-score-box{
            // height: 86px;
            margin-top: 32px;
            .max-score{
              div{
                width: 38px;
                height: 38px;
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 30px;
                font-weight: bold;
                background: #409EFF;
                text-align: center;
                line-height: 38px;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
              }
            }
            .end-btn{
              margin-top: 8px;
              background: #F9503E;
              width: 101px;
              height: 39px;
              border-radius: 4px;
              font-size: 18px;
              font-weight: 500;
              color: #fff;
              text-align: center;
              line-height: 39px;
            }
            .golden-switch{
              text-align: center;
              margin-top: 16px;
            }
            .exchange-btn{
              height: 70px;
              margin-top: 62px;
              display: flex;
              align-items: center;
              div{
                width: 100px;
                height: 36px;
                border-radius: 4px;
                border: 1px solid #C0C4CC;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                color: #303133;
                img{
                  width: 13px;
                  height: 14px;
                  margin-right: 8px;
                }
              }
            }
          }
        }
        .score{
          width: 96px;
          height: 86px;
          border-radius: 4px;
          text-align: center;
          line-height: 86px;
          font-size: 50px;
          font-weight: 600;
          // margin-top: 16px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
          background-color: #409EFF;
            .score-btn{
              position: absolute;
              right: 8px;
              bottom: 3px;
              font-size: 20px;
              font-weight: 600;
              line-height: 20px;
            }
          .subscript{
            position: absolute;
            top: -30px;
            left: -30px;
            width: 60px;
            height: 60px;
            background-color: rgba($color: #FFf, $alpha: .6);
            line-height: 0px;
            transform: rotate(45deg);
            
          }
          .iconfont{
            position: absolute;
            top: 4px;
            left: 4px;
            font-size: 16px;
            color: #fff;
            line-height: 20px;
          }
        }
        .score-minus{
          width: 96px;
          height: 24px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: bold;
          color: #fff;
          text-align: center;
          line-height: 24px;
          background-color: #409EFF;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
          margin-top: 13px;
        }
        .players{
          height: 70px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin-top: 22px;
          .player{
            display: flex;
            align-items: center;
            .seq{
              width: 23px;
              height: 23px;
              border-radius: 80px;
              background-color: #DEDFE0;
              font-size: 14px;
              font-weight: bold;
              color: #FFFFFF;
              text-align: center;
              line-height: 23px;
              margin-right: 9px;
            }
            .name{
              color: #303133;
              font-size: 16px;
            }
          }
          .active{
            .seq{
              background-color: #409EFF;
            }
            .name{
              color: #409EFF;
            }
          }
        }
        .volleyball-icon{
          height: 70px;
          line-height: 78px;
          margin-top: 22px;
          text-align: center;
          img{
            width: 23px;
            height: 23px;
          }
        }
        .pause{
          text-align: center;
          color: #606266;
          font-size: 16px;
          margin-top: 28px;
        }
        .right{
          .subscript{
            left: auto;
            right: -30px;
            top: -30px;
            width: 60px;
            height: 60px;
            background-color: rgba($color: #FFf, $alpha: .6);
            line-height: 0px;
            transform: rotate(45deg);
          }
          .iconfont{
            left: auto;
            right: 4px;
          }
        }
      }
      .tabs{
        display: flex;
        justify-content: center;
        margin-top: 30px;
        .tab{
          text-align: center;
          font-size: 12px;
          color: #303133;
          .img{
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            width: 38px;
            height: 38px;
            line-height: 38px;
            border-radius: 4px;
            background-color: #589EF8;
            margin: 0 15px;
            margin-bottom: 8px;
          }
        }
      }
    }
  }
  .pause-select{
    width: 311px;
    padding: 32px 0;
    border-radius: 8px;
    background-color: #fff;
    text-align: center;
    .title{
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 35px;
    }
    .item{
      position: relative;
      line-height: 48px;
      font-size: 16px;
      font-weight: 500;
      color: #337ECC;
      height: 48px;
      border-bottom: 1px solid #E9E9EB;
      span{
        position: absolute;
        font-size: 12px;
        color: #9E9E9E;
        right: 50px;
      }
    }
    .cancel{
      color: #C45656;
      border-bottom: none;
      margin-top: 12px;
    }
  }
  .pause-end-box{
    width: 311px;
    background-color: #fff;
    height: 240px;
    text-align: center;
    border-radius: 8px;
    .title{
      font-size: 18px;
      font-weight: 500;
      color: #303133;
      padding-top: 32px;
    }
    .time{
      font-size: 30px;
      font-weight: 600;
      color: #D9363E;
      margin-top: 20px;
    }
    .text{
      font-size: 16px;
      color: #B1B3B8;
    }
    .btn1{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 34px;
      div{
        width: 105px;
        height: 50px;
        border-radius: 3px;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        font-weight: 500;
        color: #fff;
      }
      .cancel-btn1{
        background: #409EFF;
        margin-right: 15px;
      }
      .end-btn1{
        background: #C45656;
      }
    }
  }
  .score-box{
    border-radius: 15px 15px 0px 0px;
    background-color: #fff;
    padding: 18px 25px;
    padding-bottom: 34px;
    .score-title{
      font-size: 16px;
      font-weight: 500;
      color: #1D2129;
      margin-bottom: 28px;
    }
    .score-box{
      .score-team{
        display: flex;
        justify-content: center;
        align-items: center;
        .score-team-name{
          width: 100px;
          min-width: 100px;
          text-align: center;
          margin: 0 28px;
          font-size: 16px;
          color: #303133;
        }
        
        // 场地交换样式
        &.reverse {
          flex-direction: row-reverse;
        }
      }
      .score-max{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 22px;

        div{
          width: 48px;
          min-width: 48px;
          height: 60px;
          border-radius: 3px;
          background-color: #F4F4F5;
          color: #000000;
          text-align: center;
          line-height: 60px;
          font-size: 24px;
          font-weight: 500;
          margin: 0 52px;
        }
        
        // 场地交换样式
        &.reverse {
          flex-direction: row-reverse;
        }
      }
      .score-list{
                .score-item{
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 12px;
          .score-item-score{
            width: 40px;
            height: 50px;
            border-radius: 3px;
            background: #F4F4F5;
            text-align: center;
            line-height: 50px;
            input{
              width: 100%;
              height: 100%;
              border: none;
              background: transparent;
              text-align: center;
            }
          }
          .score-item-seq{
            color: #303133;
            font-size: 15px;
            margin: 0 18.5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
              width: 12px;
              height: 12px;
              margin-bottom: 3px;
            }
            .active{
              color: #409EFF;
            }
          }
          
          // 场地交换样式
          &.reverse {
            flex-direction: row-reverse;
          }
        }
      }
    }
    .score-btn{
      padding: 0 14px;
      .revoke-btn{
        font-size: 12px;
        font-weight: 500;
        color: #C45656;
        display: flex;
        align-items: center;
        img{
          width: 16px;
          height: 16px;
          margin-right: 9px;
        }
      }
      .save-btn{
        width: 132px;
        height: 45px;
        border-radius: 5px;
        background: #409EFF;
        font-size: 15px;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        line-height: 45px;
      }
    }
  }
  .substitution-box{
    background-color: #fff;
    border-radius: 8px 8px 0 0;
    padding: 30px 24px;
    .title{
      color: #303133;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
    .box{
      margin-top: 17px;
      .team{
        flex: 1;
        text-align: center;
        .team-name{
          font-size: 16px;
          color: #303133;
        }
        .number{
          font-size: 14px;
          font-weight: 600;
          color: #9E9E9E;
          margin-top: 14px;
        }
        .minus{
          width: 120px;
          height: 60px;
          border-radius: 5px;
          background-color: #409EFF;
          font-size: 26px;
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          line-height: 60px;
          margin-top: 16px;
          display: inline-block;
        }
        .add{
          width: 80px;
          height: 40px;
          border-radius: 3px;
          background-color: #C45656;
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          text-align: center;
          line-height: 40px;
          display: inline-block;
          margin-top: 16px;
        }
      }
    }
  }
}

.disable{
  opacity: 0.7;
}
::v-deep .van-popup{
  background-color: rgba(0, 0, 0, 0);
}
</style>
